import { Button, Divider, Form, Typography } from 'antd'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { SaveOutlined, SendOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { PostAPI } from '../../redux'
import CONFIG from '../../config/env';
import { toast } from 'react-toastify';

const { Title } = CONFIG;

export default ({ url, model, setModel, onEditFormEvent, title, children, callbackPath,
    formSize, labelCol, wrapperCol, onSaveEvent,
    emptyModel, onClearModel, showModePrefix = true, saveLabel = 'Save', cancelLabel = 'Cancel', actionsSplit = false, showTopBack = false, topBackLabel = 'Back', hideBottomCancel = false }) => {
    const location = useLocation()
    const [initOke, setInitOke] = useState(false);
    const [form] = Form.useForm()

    useEffect(() => {
        if (!!location.state) {
            const locState = typeof onEditFormEvent === 'function' ? onEditFormEvent(location.state) : location.state
            setModel({ ...model, ...locState });
        }
        setInitOke(true);
    }, [location.state])
    useEffect(() => {
        document.title = `${Title} (${title})`;
    }, [])

    const dispatch = useDispatch();
    const history = useHistory();
    const SaveData = (values) => {
        const m = { ...model, ...values };
        const data = (typeof onSaveEvent === 'function' && onSaveEvent(m)) || m;
        if (!url) return false;
        dispatch(PostAPI({ url, data, callbackPath })).then(resp => {
            if (!!resp?.payload) {
                if (!!callbackPath) {
                    history.push({ pathname: callbackPath })
                }
                else {
                    setInitOke(false);
                    const m = (!!onClearModel && typeof onClearModel === 'function' && onClearModel(model)) || emptyModel;
                    setModel(m);
                    setTimeout(() => {
                        setInitOke(true);
                    }, 50)
                }
                toast.success("Data Tersimpan!");
            }
        })
    }
    const initValue = useMemo(() => {
        form.setFieldsValue(model);
    }, [form, model])

    return initOke && (
        <Fragment>
            {showTopBack ? (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography.Title level={4} style={{ margin: 0 }}>{showModePrefix ? `${model?.isCreate ? 'Create' : 'Edit'} ` : ''}{title}</Typography.Title>
                    <Button icon={<ArrowLeftOutlined />} onClick={() => history.goBack()}>
                        {topBackLabel}
                    </Button>
                </div>
            ) : (
                <Typography.Title level={4}>{showModePrefix ? `${model?.isCreate ? 'Create' : 'Edit'} ` : ''}{title}</Typography.Title>
            )}
            <Divider style={{ marginBlock: 16 }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Form name={title} size={formSize || 'middle'} onFinish={SaveData}
                    form={form}
                    autoComplete="off"
                    labelCol={labelCol}
                    wrapperCol={wrapperCol}
                    layout={'vertical'}
                    initialValues={{ ...initValue }}>
                    {children}
                    {url &&
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: (!hideBottomCancel && actionsSplit) ? 'space-between' : 'flex-end', marginBlock: 16 }}>
                            {hideBottomCancel ? (
                                <Form.Item label=" " colon={false} noStyle>
                                    <Button size='large' icon={saveLabel === 'Send' ? <SendOutlined /> : <SaveOutlined />} type="primary" htmlType='submit' >
                                        {saveLabel}
                                    </Button>
                                </Form.Item>
                            ) : actionsSplit ? (
                                <Fragment>
                                    <Form.Item label=" " colon={false} noStyle>
                                        <Button size='large' icon={<ArrowLeftOutlined />} type="primary" danger onClick={() => history.goBack()} >
                                            {cancelLabel}
                                        </Button>
                                    </Form.Item>
                                    <Form.Item label=" " colon={false} noStyle>
                                        <Button size='large' icon={saveLabel === 'Send' ? <SendOutlined /> : <SaveOutlined />} type="primary" htmlType='submit' >
                                            {saveLabel}
                                        </Button>
                                    </Form.Item>
                                </Fragment>
                            ) : (
                                <Form.Item label=" " colon={false} noStyle>
                                    <Button size='large' style={{ marginInline: 16 }} icon={<SaveOutlined />} type="primary" htmlType='submit' >
                                        {saveLabel}
                                    </Button>
                                    <Button size='large' icon={<ArrowLeftOutlined />} type="primary" danger onClick={() => history.goBack()} >
                                        {cancelLabel}
                                    </Button>
                                </Form.Item>
                            )}
                        </div>
                    }
                </Form>
            </div>
        </Fragment>
    )
}